// this is an auto generated file. This will be overwritten

export const getDanceStyle = /* GraphQL */ `
  query GetDanceStyle($id: ID!) {
    getDanceStyle(id: $id) {
      beatsPerBar
      createdAt
      discipline
      id
      name
      patterns {
        nextToken
        __typename
      }
      routines {
        nextToken
        __typename
      }
      status
      updatedAt
      __typename
    }
  }
`;
export const getPattern = /* GraphQL */ `
  query GetPattern($id: ID!) {
    getPattern(id: $id) {
      createdAt
      danceStyle {
        beatsPerBar
        createdAt
        discipline
        id
        name
        status
        updatedAt
        __typename
      }
      danceStylePatternsId
      id
      name
      order
      status
      updatedAt
      variations {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const getRoutine = /* GraphQL */ `
  query GetRoutine($id: ID!) {
    getRoutine(id: $id) {
      createdAt
      danceStyle {
        beatsPerBar
        createdAt
        discipline
        id
        name
        status
        updatedAt
        __typename
      }
      danceStyleRoutinesId
      id
      name
      owner
      patternList
      status
      updatedAt
      videos
      __typename
    }
  }
`;
export const getVariation = /* GraphQL */ `
  query GetVariation($id: ID!) {
    getVariation(id: $id) {
      beats
      createdAt
      hold
      id
      level
      order
      pattern {
        createdAt
        danceStylePatternsId
        id
        name
        order
        status
        updatedAt
        __typename
      }
      patternVariationsId
      rhytm
      rhytmMan
      status
      updatedAt
      videos {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const getVideo = /* GraphQL */ `
  query GetVideo($id: ID!) {
    getVideo(id: $id) {
      createdAt
      id
      order
      status
      updatedAt
      url
      variation {
        beats
        createdAt
        hold
        id
        level
        order
        patternVariationsId
        rhytm
        rhytmMan
        status
        updatedAt
        __typename
      }
      variationVideosId
      __typename
    }
  }
`;
export const listDanceStyles = /* GraphQL */ `
  query ListDanceStyles(
    $filter: ModelDanceStyleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDanceStyles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        beatsPerBar
        createdAt
        discipline
        id
        name
        status
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listPatterns = /* GraphQL */ `
  query ListPatterns(
    $filter: ModelPatternFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPatterns(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        danceStylePatternsId
        id
        name
        order
        status
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listRoutines = /* GraphQL */ `
  query ListRoutines(
    $filter: ModelRoutineFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRoutines(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        danceStyleRoutinesId
        id
        name
        owner
        patternList
        status
        updatedAt
        videos
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listVariations = /* GraphQL */ `
  query ListVariations(
    $filter: ModelVariationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVariations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        beats
        createdAt
        hold
        id
        level
        order
        patternVariationsId
        rhytm
        rhytmMan
        status
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listVideos = /* GraphQL */ `
  query ListVideos(
    $filter: ModelVideoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVideos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        id
        order
        status
        updatedAt
        url
        variationVideosId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
